import { reactive } from 'vue';

export const Modal = reactive({
  alert: () => {},
  error: () => {},
  confirm: () => {},
  dialog: () => {}
});

export const OverlayModal = reactive({
  alert: () => {},
  error: () => {},
  confirm: () => {},
  dialog: () => {}
});
